import { Heading, Scroll } from '@dreryk/react-components';

import { referralTranslationKeys } from '../translations';

import { ReferralToAnalyticalExaminationForm } from './ReferralToAnalyticalExaminationForm/ReferralToAnalyticalExaminationForm';
import { ReferralToAnalyticalExaminationPanelLoader } from './ReferralToAnalyticalExaminationPanel.loader';
import { ReferralToAnalyticalExaminationRouteLeavingGuard } from './ReferralToAnalyticalExaminationRouteLeavingGuard';
import { ReferralToAnalyticalExaminationSendAction } from './ReferralToAnalyticalExaminationSendAction/ReferralToAnalyticalExaminationSendAction';

type ReferralToAnalyticalExaminationPanelProps = {
   readonly visitId: number;
};

export const ReferralToAnalyticalExaminationPanel = (props: ReferralToAnalyticalExaminationPanelProps): JSX.Element => {
   return (
      <Scroll testId={'referralToAnalyticalExamination'}>
         <ReferralToAnalyticalExaminationPanelLoader visitId={props.visitId}>
            {({ referralToAnalyticalExaminationDraft }) => (
               <>
                  <Heading
                     testId={'analyticalExamination'}
                     type={'h1'}
                     content={referralTranslationKeys.referralType.ANALYTICAL_EXAMINATION}
                  />
                  <ReferralToAnalyticalExaminationForm
                     referralToAnalyticalExaminationDraft={referralToAnalyticalExaminationDraft}
                  >
                     {({ handleSubmit, handleSubmitDraft, formState, reset }) => (
                        <>
                           <ReferralToAnalyticalExaminationSendAction
                              visitId={props.visitId}
                              handleSubmit={handleSubmit}
                              onSuccess={reset}
                           />
                           <ReferralToAnalyticalExaminationRouteLeavingGuard
                              handleSubmitDraft={handleSubmitDraft}
                              formState={formState}
                              visitId={props.visitId}
                           />
                        </>
                     )}
                  </ReferralToAnalyticalExaminationForm>
               </>
            )}
         </ReferralToAnalyticalExaminationPanelLoader>
      </Scroll>
   );
};
